import React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';

const calculateServiceStats = dataCenters => {
  const stats = { ok: 0, warning: 0, critical: 0, unknown: 0, pending: 0 };
  dataCenters.forEach(center =>
    center.hosts.forEach(host => {
      stats.ok += host.services.ok;
      stats.warning += host.services.warning;
      stats.critical += host.services.critical;
      stats.unknown += host.services.unknown;
      stats.pending += host.services.pending;
    }),
  );
  return stats;
};

const ServiceStat = ({ name, count, color }) => {
  return (
    <div style={{ whiteSpace: 'nowrap', marginTop: 4 }}>
      <span className={`text-${color}`} style={{ paddingRight: 4 }}>&#11044;</span>
      <small>{name} {count > 0 && `(${count})`}</small>
    </div>
  );
};

const ServiceStats = ({ dataCenters }) => {
  const { ok, warning, critical, unknown, pending } = calculateServiceStats(dataCenters);
  const total = ok + warning + critical + unknown + pending;
  return (
    <Card style={{ textAlign: 'left', background: 'none', border: 0 }}>
      <CardHeader style={{ background: 'none', border: 0 }}>
        Services <small>{total > 0 && `(${total})`}</small>
      </CardHeader>
      <CardBody style={{ paddingTop: 6, minWidth: 96, borderTop: '1px solid #ddd' }}>
        <ServiceStat name="Critical" count={critical} color="danger" />
        <ServiceStat name="Warning" count={warning} color="warning" />
        <ServiceStat name="OK" count={ok} color="success" />
        <ServiceStat name="Pending" count={pending} color="info" />
        <ServiceStat name="Unknown" count={unknown} color="dark" />
      </CardBody>
    </Card>
  );
};

export default ServiceStats;
